import { useTranslation } from 'react-i18next';
import { mainSiteUrl } from '@/mocks/categories';

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="relative py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20soft%20pastel%20toned%20fashion%20flat%20lay%20with%20neutral%20textiles%20and%20accessories%20on%20cream%20background%2C%20airy%20minimal%20composition%2C%20elevated%20European%20editorial%20photography%2C%20soft%20natural%20lighting%2C%20calm%20peaceful%20aesthetic&width=1600&height=800&seq=cta-final-bg&orientation=landscape"
          alt="YOYBUY Finds background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-foreground-950/50"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto text-center px-4 md:px-6">
        <h2 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 tracking-wider mb-6">
          {t('finalCta.title')}
        </h2>
        <p className="text-sm md:text-base text-background-50/80 max-w-lg mx-auto leading-relaxed">
          {t('finalCta.subtitle')}
        </p>
        <a
          href={mainSiteUrl}
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-3 mt-10 px-8 py-4 rounded-full bg-foreground-950 text-background-50 text-sm font-semibold hover:bg-foreground-900 transition-all duration-300 whitespace-nowrap cursor-pointer group"
        >
          <span className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-shopping-bag-3-line"></i>
          </span>
          {t('finalCta.button')}
          <span className="w-5 h-5 flex items-center justify-center group-hover:translate-x-0.5 transition-transform">
            <i className="ri-arrow-right-up-line"></i>
          </span>
        </a>
      </div>
    </section>
  );
}